import script from "./SocialContent.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialContent.vue?vue&type=script&setup=true&lang=js"

import "./SocialContent.vue?vue&type=style&index=0&id=ed229fbc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed229fbc"]])

export default __exports__